import { defineMessages } from "react-intl";
const messages = defineMessages({
    dataExchangeDetailsTitle: {
        id: "app.space.details.dataExchangeDetails.title",
        defaultMessage: "{name} Data Exchange",
    },
    dataExchangeDetailsSubtitle: {
        id: "app.space.details.dataExchangeDetails.subtitle",
        defaultMessage: "Data was last synced for this Unit on {date}, {time} EST.",
    },
    dataExchangeDetailsSubtitleLoading: {
        id: "app.space.details.dataExchangeDetails.subtitle.loading",
        defaultMessage: "Data exchange is being synchronized.",
    },
    dataExchangeDetailsSubtitleUnavailable: {
        id: "app.space.details.dataExchangeDetails.subtitle.unavailable",
        defaultMessage: "This Unit is currently not set up to sync with any property management system.",
    },
    dataExchangeDetailsDone: {
        id: "app.space.details.dataExchangeDetails.done",
        defaultMessage: "Done",
    },
    dataExchangeDetailsUnitNumber: {
        id: "app.space.details.dataExchangeDetails.unitNumber",
        defaultMessage: "Unit Number",
    },
    dataExchangeDetailsBRBA: {
        id: "app.space.details.dataExchangeDetails.BRBA",
        defaultMessage: "BR/BA",
    },
    dataExchangeDetailsPrice: {
        id: "app.space.details.dataExchangeDetails.price",
        defaultMessage: "Price",
    },
    dataExchangeDetailsFloorplan: {
        id: "app.space.details.dataExchangeDetails.floorplan",
        defaultMessage: "Floorplan",
    },
    dataExchangeDetailsAvailability: {
        id: "app.space.details.dataExchangeDetails.availability",
        defaultMessage: "Availability",
    },
    dataExchangeDetailsPriceContent: {
        id: "app.space.details.dataExchangeDetails.price.content",
        defaultMessage: "${price} ({term} months term)",
    },
    dataExchangeDetailsMetaPriceContent: {
        id: "app.space.details.dataExchangeDetails.metaPrice.content",
        defaultMessage: "${price} ({metaField})",
    },
    dataExchangeDetailsNotFound: {
        id: "app.space.details.dataExchangeDetails.notFound",
        defaultMessage: "NOT FOUND",
    },
});
export default messages;
